import { BASE_URL, CONFIG, ENVIRONMENT_NAME } from '../config';
import { useCallback, useMemo } from 'react';
import i18n from '../i18n';
import { useAdminAuth } from '../contexts/AdminAuthContext';

const NOOP = () => {};
export default function useAdminFetchApi(showNotification = NOOP) {
  const baseUrl = BASE_URL + 'api';
  const { adminToken } = useAdminAuth();

  const request = useCallback(async (endpoint, options = {}) => {
    const url = `${baseUrl}${endpoint}`;
    let lang = i18n?.language || 'en';
    try {
      const firstSegment = (window.location.pathname || '').split('/')[1] || '';
      const availableLangs = Object.keys(i18n?.options?.resources || {});
      if (firstSegment && availableLangs.includes(firstSegment)) lang = firstSegment;
    } catch (_) {}

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': lang,
        'X-Environment': ENVIRONMENT_NAME,
        ...(options.headers || {}),
      },
      credentials: 'include',
      timeout: CONFIG.api.timeout,
      ...options,
    };

    if (adminToken && !options.skipAuth) {
      config.headers['Authorization'] = `Bearer ${adminToken}`;
    }
    if (options.body instanceof FormData) delete config.headers['Content-Type'];

    try {
      const resp = await fetch(url, config);
      const contentType = resp.headers.get('content-type');
      const data = contentType && contentType.includes('application/json') ? await resp.json() : { message: await resp.text() };
      if (!resp.ok) {
        const msg = data?.error || 'Request failed';
        const err = new Error(msg);
        err.status = resp.status;
  if (showNotification !== false) showNotification(msg, 'error');
        throw err;
      }
      return data;
    } catch (e) {
      if (CONFIG.features.debug) console.error('[ADMIN API ERROR]', e);
      throw e;
    }
  }, [adminToken]);

  const api = useMemo(() => ({
    get: (e, o) => request(e, { method: 'GET', ...(o || {}) }),
    post: (e, b, o) => request(e, { method: 'POST', body: b instanceof FormData ? b : JSON.stringify(b), ...(o || {}) }),
    put: (e, b, o) => request(e, { method: 'PUT', body: b instanceof FormData ? b : JSON.stringify(b), ...(o || {}) }),
    delete: (e, o) => request(e, { method: 'DELETE', ...(o || {}) }),
  }), [request]);

  return api;
}
